import React from "react";
import Card from "../card/Card";
import CardList from "../card/CardList";

const ProductList = ({ data, meta, currentPage, onPageChange, viewMode = "grid" }) => {
  return (
    <div>
      {viewMode === "grid" ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
          {data.map((item, index) => (
            <Card key={item.id ?? index} data={item} />
          ))}
        </div>
      ) : (
        <div className="flex flex-col gap-3">
          {data.map((item, index) => (
            <CardList key={item.id ?? index} data={item} />
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductList;
